export default "__VITE_ASSET__Dmq2lrw2__"